<crm-multi-select
  #multiSelectComponent
  [options]="contragents"
  [(selectedItems)]="_selectedContragents"
  (selectedItemsChange)="onSelect($event)"
  (panelShow)="onShowPanel()"
  (onFilter)="searchContragent($event.filter)"
  [showToggleAll]="true"
  [virtualScroll]="true"
  [virtualScrollItemSize]="45"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [label]="label"
  [disabled]="disabled"
  [appendTo]="appendTo"
  [showClear]="showClear"
  [placeholder]="placeholder"
  filterBy="name,inn">
  <ng-template
    #selectedItemsTemplate
    let-contragents="items">
    <ng-container *ngFor="let contragent of contragents; last as isLast">
      {{ toContragent(contragent)?.name }}{{ isLast ? '' : ', ' }}
    </ng-container>
  </ng-template>
  <ng-template
    #itemTemplate
    let-contragent="item">
    <ng-container *ngIf="toContragent(contragent) as contragent">
      <div>
        <div>{{ contragent.name }}</div>
        <div class="frm-color-green">{{ contragent.inn }}</div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-multi-select>
